var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-compatibility-warning"},[_c('p',{staticClass:"mb-0"},[_c('span',[_vm._v(_vm._s(_vm.$t('_page.error.browser_incompatible')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }